var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('v-chip',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.text))]):_c('span',[_vm._v(" - ")])
}
var staticRenderFns = []

export { render, staticRenderFns }